import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faSignOut,
  faBriefcase,
  faEnvelope,
  faFileAlt,
  faChartBar,
} from "@fortawesome/free-solid-svg-icons";
import { Button, NavBar } from "./AdminStyles";

const Navbar = ({ userName, activePage, handlePageChange, handleLogout }) => {
  return (
    <NavBar>
      <span style={{ marginLeft: "20px" }}>
        <FontAwesomeIcon
          icon={faUser}
          size="xs"
          style={{ marginRight: "10px" }}
        />
        {userName}
      </span>
      <div className="nav-links">
        <button
          className={`nav-link ${
            activePage === "vacaturebeheer" ? "active" : ""
          }`}
          onClick={() => handlePageChange("vacaturebeheer")}
        >
          <FontAwesomeIcon icon={faBriefcase} style={{ marginRight: "8px" }} />
          Vacaturebeheer
        </button>
        <button
          className={`nav-link ${activePage === "berichten" ? "active" : ""}`}
          onClick={() => handlePageChange("berichten")}
        >
          <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: "8px" }} />
          Berichten
        </button>
        <button
          className={`nav-link ${
            activePage === "sollicitaties" ? "active" : ""
          }`}
          onClick={() => handlePageChange("sollicitaties")}
        >
          <FontAwesomeIcon icon={faFileAlt} style={{ marginRight: "8px" }} />
          Sollicitaties
        </button>
        <button
          className={`nav-link ${
            activePage === "statistieken" ? "active" : ""
          }`}
          onClick={() => handlePageChange("statistieken")}
        >
          <FontAwesomeIcon icon={faChartBar} style={{ marginRight: "8px" }} />
          Statistieken
        </button>
      </div>
      <Button
        onClick={handleLogout}
        style={{ width: "10%", marginTop: "0", backgroundColor: "white" }}
      >
        <FontAwesomeIcon icon={faSignOut} style={{ color: "#17224d" }} />
      </Button>
    </NavBar>
  );
};

export default Navbar;
